const PortfolioStyles = () => {
  return (
    <style jsx>{`
      .project-detail-page {
        font-family:
          -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }

      /* Hero Section - Matching Home Page */
      .project-hero {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        padding: 80px 0 60px;
        position: relative;
        overflow: hidden;
      }

      .project-hero::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
          radial-gradient(
            circle at 20% 80%,
            rgba(255, 215, 0, 0.15) 0%,
            transparent 50%
          ),
          radial-gradient(
            circle at 80% 20%,
            rgba(255, 255, 255, 0.05) 0%,
            transparent 50%
          );
      }

      .hero-content {
        max-width: 1000px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
      }

      .breadcrumb-nav {
        margin-bottom: 24px;
      }

      .breadcrumb {
        display: flex;
        align-items: center;
        gap: 8px;
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .breadcrumb-item {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }

      .breadcrumb-item a {
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        transition: color 0.3s ease;
      }

      .breadcrumb-item a:hover {
        color: #ffd700;
      }

      .breadcrumb-item.active {
        color: #ffd700;
        font-weight: 600;
      }

      .breadcrumb-item:not(:last-child)::after {
        content: "/";
        margin: 0 8px;
        color: rgba(255, 255, 255, 0.5);
      }

      .hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 24px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .badge-icon {
        font-size: 20px;
      }

      .badge-text {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .hero-title {
        font-size: clamp(2.5rem, 5vw, 3.5rem);
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
        background: linear-gradient(to right, #ffffff 0%, #e6f0ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .hero-subtitle {
        font-size: 1.25rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.9);
        max-width: 800px;
        margin-bottom: 40px;
      }

      .client-info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 24px;
        margin-top: 40px;
      }

      .info-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
      }

      .info-item:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-2px);
      }

      .info-icon {
        font-size: 24px;
        width: 48px;
        height: 48px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .info-content {
        flex: 1;
      }

      .info-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 4px;
      }

      .info-value {
        font-size: 16px;
        font-weight: 600;
        color: white;
      }

      /* Hero Image */
      .hero-image-section {
        padding: 40px 0;
        position: relative;
        margin-top: -60px;
      }

      .hero-image-container {
        position: relative;
        border-radius: 24px;
        overflow: hidden;
        box-shadow: 0 40px 80px rgba(0, 0, 0, 0.2);
      }

      .hero-image {
        width: 100%;
        height: auto;
        display: block;
        transition: transform 0.5s ease;
      }

      .hero-image:hover {
        transform: scale(1.02);
      }

      .image-overlay {
        position: absolute;
        bottom: 20px;
        right: 20px;
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        color: white;
        font-size: 14px;
        font-weight: 600;
      }

      /* Section Styles */
      .section-header {
        text-align: center;
        margin-bottom: 60px;
      }

      .section-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(10, 36, 88, 0.1);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 16px;
      }

      .section-badge .badge-icon {
        font-size: 18px;
        color: #0a2458;
      }

      .section-badge .badge-text {
        color: #0a2458;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 1px;
      }

      .section-title {
        font-size: clamp(2rem, 4vw, 2.75rem);
        color: #0a2458;
        font-weight: 700;
        margin-bottom: 16px;
      }

      .section-subtitle {
        font-size: 1.125rem;
        color: #0a2458;
        max-width: 600px;
        margin: 0 auto;
        line-height: 1.6;
      }

      /* Results Section */
      .results-section {
        padding: 100px 0;
        background: #f8fafc;
      }

      .metrics-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 30px;
        max-width: 1000px;
        margin: 0 auto;
      }

      .metric-card {
        background: white;
        border-radius: 20px;
        padding: 40px 30px;
        text-align: center;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
      }

      .metric-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      }

      .metric-icon {
        font-size: 48px;
        margin-bottom: 20px;
      }

      .metric-value {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 8px;
      }

      .metric-label {
        font-size: 1.125rem;
        color: #0a2458;
        font-weight: 500;
      }

      /* Challenge Section */
      .challenge-section {
        padding: 100px 0;
        background: white;
      }

      .pain-points-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 30px;
        margin: 60px 0;
      }

      .pain-point-card {
        background: #fff8f8;
        border-left: 4px solid #ff4757;
        border-radius: 12px;
        padding: 30px;
        transition: all 0.3s ease;
      }

      .pain-point-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(255, 71, 87, 0.1);
      }

      .pain-point-icon {
        font-size: 40px;
        margin-bottom: 20px;
      }

      .pain-point-title {
        font-size: 1.25rem;
        color: #0a2458;
        font-weight: 600;
        margin-bottom: 12px;
      }

      .pain-point-description {
        color: #666;
        line-height: 1.6;
      }

      .challenge-list {
        background: #f8fafc;
        border-radius: 20px;
        padding: 40px;
        margin: 60px 0;
      }

      .list-title {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 24px;
      }

      .challenge-items {
        list-style: none;
        padding: 0;
      }

      .challenge-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 16px;
        padding: 12px 0;
        border-bottom: 1px solid #eaeaea;
      }

      .challenge-item:last-child {
        border-bottom: none;
      }

      .item-icon {
        color: #ff4757;
        font-size: 20px;
        margin-top: 2px;
      }

      .item-text {
        flex: 1;
        color: #666;
        line-height: 1.6;
      }

      .quote-card {
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f0ff 100%);
        border-radius: 20px;
        padding: 40px;
        margin-top: 60px;
        text-align: center;
        border: 1px solid #e2e8f0;
      }

      .quote-icon {
        font-size: 40px;
        margin-bottom: 20px;
        color: #0a2458;
      }

      .quote-text {
        font-size: 1.5rem;
        font-style: italic;
        color: #0a2458;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .quote-author {
        font-size: 1rem;
        color: #666;
      }

      .quote-author strong {
        color: #0a2458;
        display: block;
        margin-bottom: 4px;
      }

      /* Solution Section */
      .solution-section {
        padding: 100px 0;
        background: #f8fafc;
      }

      .features-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 40px;
        max-width: 1200px;
        margin: 0 auto;
      }

      .feature-card {
        background: white;
        border-radius: 20px;
        padding: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
      }

      .feature-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        border-left: 4px solid #0a2458;
      }

      .feature-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 20px;
      }

      .feature-icon {
        font-size: 40px;
        width: 70px;
        height: 70px;
        background: rgba(10, 36, 88, 0.1);
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .feature-title {
        font-size: 1.5rem;
        color: #0a2458;
        font-weight: 600;
        margin: 0;
      }

      .feature-description {
        color: #666;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .feature-details {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .detail-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 12px;
        padding: 8px 0;
      }

      .detail-icon {
        color: #10b981;
        font-weight: bold;
        margin-top: 2px;
      }

      .detail-text {
        color: #666;
        line-height: 1.5;
      }

      /* Screenshots */
      .screenshots-section {
        padding: 100px 0;
        background: white;
      }

      .screenshot-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px;
        align-items: center;
        margin-bottom: 100px;
      }

      .screenshot-container.reversed {
        direction: rtl;
      }

      .screenshot-container.reversed > * {
        direction: ltr;
      }

      .screenshot-image {
        position: relative;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
      }

      .screenshot-img {
        width: 100%;
        height: auto;
        display: block;
        transition: transform 0.5s ease;
      }

      .screenshot-image:hover .screenshot-img {
        transform: scale(1.05);
      }

      .screenshot-overlay {
        position: absolute;
        top: 20px;
        left: 20px;
        background: rgba(10, 36, 88, 0.9);
        color: white;
        padding: 8px 16px;
        border-radius: 50px;
        font-size: 12px;
        font-weight: 600;
      }

      .screenshot-content {
        padding: 20px;
      }

      .screenshot-title {
        font-size: 2rem;
        color: #0a2458;
        margin-bottom: 20px;
      }

      .screenshot-description {
        font-size: 1.125rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 30px;
      }

      .screenshot-badge {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
      }

      .tech-badge {
        background: #e6f0ff;
        color: #0a2458;
        padding: 8px 16px;
        border-radius: 50px;
        font-size: 14px;
        font-weight: 600;
      }

      /* Technical Section */
      .technical-section {
        padding: 100px 0;
        background: #f8fafc;
      }

      .technical-content {
        max-width: 1000px;
        margin: 0 auto;
      }

      .tech-stack,
      .key-features {
        margin-bottom: 60px;
      }

      .tech-title {
        font-size: 2rem;
        color: #0a2458;
        margin-bottom: 40px;
        text-align: center;
      }

      .stack-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
      }

      .stack-item {
        background: white;
        border-radius: 16px;
        padding: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
      }

      .stack-item:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      }

      .stack-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }

      .stack-icon {
        font-size: 24px;
      }

      .stack-name {
        font-size: 1.25rem;
        color: #0a2458;
        font-weight: 600;
        margin: 0;
      }

      .stack-description {
        color: #666;
        line-height: 1.6;
        margin: 0;
      }

      .features-list {
        display: grid;
        gap: 20px;
      }

      .feature-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 20px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      }

      .feature-icon {
        color: #0a2458;
        font-size: 20px;
        margin-top: 2px;
      }

      .feature-text {
        color: #666;
        line-height: 1.6;
        flex: 1;
      }

      /* Detailed Results */
      .detailed-results-section {
        padding: 100px 0;
        background: white;
      }

      .results-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 40px;
        max-width: 1200px;
        margin: 0 auto;
      }

      .result-card {
        background: linear-gradient(135deg, #f8fafc 0%, #f0f7ff 100%);
        border-radius: 20px;
        padding: 40px;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease;
      }

      .result-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        border-color: #0a2458;
      }

      .result-title {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 2px solid #e2e8f0;
      }

      .result-achievements {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .achievement-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 16px;
        padding: 12px 0;
        border-bottom: 1px solid #eaeaea;
      }

      .achievement-item:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }

      .achievement-icon {
        color: #10b981;
        font-weight: bold;
        font-size: 20px;
        margin-top: 2px;
      }

      .achievement-text {
        color: #666;
        line-height: 1.6;
        flex: 1;
      }

      /* Timeline */
      .timeline-section {
        padding: 100px 0;
        background: #f8fafc;
      }

      .timeline {
        max-width: 800px;
        margin: 0 auto;
      }

      .timeline-phase {
        margin-bottom: 40px;
        position: relative;
      }

      .timeline-phase:not(:last-child)::after {
        content: "";
        position: absolute;
        left: 25px;
        top: 80px;
        bottom: -40px;
        width: 2px;
        background: #e2e8f0;
      }

      .phase-header {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 24px;
      }

      .phase-number {
        width: 50px;
        height: 50px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.25rem;
        font-weight: 700;
        position: relative;
        z-index: 1;
      }

      .phase-title h3 {
        font-size: 1.5rem;
        color: #0a2458;
        margin: 0 0 4px 0;
      }

      .phase-duration {
        font-size: 0.875rem;
        color: #0a2458;
        background: #e6f0ff;
        padding: 4px 12px;
        border-radius: 50px;
        font-weight: 600;
      }

      .phase-content {
        margin-left: 70px;
      }

      .phase-activities {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .activity-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 12px;
        padding: 12px 0;
        border-bottom: 1px solid #eaeaea;
      }

      .activity-item:last-child {
        border-bottom: none;
      }

      .activity-icon {
        color: #0a2458;
        font-weight: bold;
      }

      .activity-text {
        color: #666;
        line-height: 1.6;
        flex: 1;
      }

      /* Testimonial */
      .testimonial-section {
        padding: 100px 0;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
      }

      .testimonial-card {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        border-radius: 30px;
        padding: 60px;
        max-width: 800px;
        margin: 0 auto;
        text-align: center;
        box-shadow: 0 40px 80px rgba(0, 0, 0, 0.2);
      }

      .testimonial-rating {
        margin-bottom: 30px;
      }

      .star {
        font-size: 32px;
        margin: 0 4px;
        color: #ffd700;
      }

      .testimonial-text {
        font-size: 1.5rem;
        font-style: italic;
        color: #0a2458;
        line-height: 1.6;
        margin-bottom: 40px;
      }

      .testimonial-author {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
      }

      .author-avatar {
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
      }

      .author-name {
        font-size: 1.25rem;
        color: #0a2458;
        font-weight: 600;
        margin-bottom: 4px;
      }

      .author-role {
        color: #0a2458;
        font-size: 1rem;
      }

      /* Technologies */
      .technologies-section {
        padding: 80px 0;
        background: #f8fafc;
      }

      .technologies-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 30px;
        max-width: 800px;
        margin: 0 auto;
      }

      .technology-card {
        background: white;
        border-radius: 20px;
        padding: 40px 20px;
        text-align: center;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
      }

      .technology-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        border: 2px solid #e2e8f0;
      }

      .tech-icon {
        font-size: 48px;
        margin-bottom: 20px;
      }

      .tech-name {
        font-size: 1.125rem;
        color: #0a2458;
        font-weight: 600;
      }

      /* Related Projects */
      .related-projects-section {
        padding: 100px 0;
        background: white;
      }

      .projects-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 40px;
        margin-bottom: 60px;
      }

      .project-card {
        background: white;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .project-card:hover {
        transform: translateY(-10px);
        box-shadow: 0 40px 60px rgba(0, 0, 0, 0.15);
      }

      .project-image {
        position: relative;
        height: 200px;
        overflow: hidden;
      }

      .project-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .project-card:hover .project-image img {
        transform: scale(1.1);
      }

      .project-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(10, 36, 88, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      .project-card:hover .project-overlay {
        opacity: 1;
      }

      .view-text {
        color: white;
        font-weight: 600;
        font-size: 18px;
      }

      .project-content {
        padding: 30px;
      }

      .project-category {
        display: inline-block;
        background: #e6f0ff;
        color: #0a2458;
        padding: 6px 12px;
        border-radius: 50px;
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      .project-title {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 20px;
        line-height: 1.3;
      }

      .project-link {
        color: #0a2458;
        font-weight: 600;
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .view-all {
        text-align: center;
      }

      .view-all-btn {
        display: inline-block;
        background: transparent;
        color: #0a2458;
        border: 2px solid #0a2458;
        padding: 16px 40px;
        border-radius: 50px;
        font-weight: 600;
        font-size: 1.125rem;
        text-decoration: none;
        transition: all 0.3s ease;
      }

      .view-all-btn:hover {
        background: #0a2458;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(10, 36, 88, 0.3);
      }

      /* CTA Section */
      .cta-section {
        padding: 100px 0;
        background: linear-gradient(135deg, #f8fafc 0%, #f0f7ff 100%);
      }

      .cta-card {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 30px;
        padding: 80px;
        text-align: center;
        color: white;
        box-shadow: 0 40px 80px rgba(10, 36, 88, 0.2);
      }

      .cta-title {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 24px;
        line-height: 1.2;
      }

      .cta-subtitle {
        font-size: 1.25rem;
        opacity: 0.9;
        max-width: 700px;
        margin: 0 auto 60px;
        line-height: 1.6;
      }

      .cta-buttons {
        display: flex;
        justify-content: center;
        gap: 24px;
        flex-wrap: wrap;
      }

      .cta-primary {
        background: #ffd700;
        color: #0a2458;
        border: none;
        padding: 20px 40px;
        border-radius: 50px;
        font-weight: 600;
        font-size: 1.125rem;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .cta-primary:hover {
        transform: translateY(-3px);
        box-shadow: 0 15px 30px rgba(255, 215, 0, 0.3);
      }

      .cta-secondary {
        background: transparent;
        color: white;
        border: 2px solid rgba(255, 255, 255, 0.3);
        padding: 20px 40px;
        border-radius: 50px;
        font-weight: 600;
        font-size: 1.125rem;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .cta-secondary:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: white;
        transform: translateY(-3px);
      }

      /* Responsive Design */
      @media (max-width: 992px) {
        .screenshot-container {
          grid-template-columns: 1fr;
          gap: 40px;
        }

        .client-info-grid {
          grid-template-columns: repeat(2, 1fr);
        }

        .features-grid,
        .results-grid,
        .projects-grid {
          grid-template-columns: 1fr;
        }

        .cta-buttons {
          flex-direction: column;
          align-items: center;
        }

        .cta-card {
          padding: 60px 40px;
        }
      }

      @media (max-width: 768px) {
        .project-hero,
        .results-section,
        .challenge-section,
        .solution-section,
        .screenshots-section,
        .technical-section,
        .detailed-results-section,
        .timeline-section,
        .testimonial-section,
        .related-projects-section,
        .cta-section {
          padding: 60px 0;
        }

        .client-info-grid {
          grid-template-columns: 1fr;
        }

        .metrics-grid {
          grid-template-columns: repeat(2, 1fr);
        }

        .phase-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
        }

        .phase-content {
          margin-left: 0;
        }

        .timeline-phase:not(:last-child)::after {
          left: 25px;
          top: 110px;
        }

        .cta-title {
          font-size: 2.5rem;
        }
      }

      @media (max-width: 576px) {
        .metrics-grid {
          grid-template-columns: 1fr;
        }

        .pain-points-grid {
          grid-template-columns: 1fr;
        }

        .hero-title {
          font-size: 2rem;
        }

        .hero-subtitle {
          font-size: 1rem;
        }

        .cta-card {
          padding: 40px 20px;
        }

        .cta-title {
          font-size: 2rem;
        }
      }
    `}</style>
  );
};

export default PortfolioStyles;
